module.exports = __webpack_public_path__ + "static/media/GolosText-Bold.3f44d208.ttf";